import axios from 'axios';
import { push } from 'connected-react-router';
import { setMessage } from './utils';

export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_DONE = 'FETCH_USER_DONE';
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR';
export const SELECT_USER = 'SELECT_USER';
export const loadUsers = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_USER });
    let res = await axios.get('/api/users');
    dispatch({ type: FETCH_USER_DONE, users: res.data });
  } catch (error) {
    dispatch(push('/'));
    dispatch({ type: FETCH_USER_ERROR, error });
    dispatch(setMessage(' '));
  }
};
export const selectUser = (user) => (dispatch) => {
  dispatch({ type: SELECT_USER, user });
};
export const saveUser = (user) => async (dispatch) => {
  try {
    await axios.put('/api/users', user);
    dispatch(loadUsers());
  } catch (error) {
    dispatch(setMessage(' '));
  }
};
export const deleteUser = (user) => async (dispatch) => {
  try {
    await axios.delete(`/api/users/${user?.seq}`);
    dispatch(loadUsers());
  } catch (error) {
    setMessage(' ');
  }
};

